import { jsx as _jsx } from "react/jsx-runtime";
import { StyledList } from "./List.style";
const List = ({ children }) => {
    return _jsx(StyledList, { children: children });
};
export default List;
//# sourceMappingURL=List.js.map